export const overallMorningStarRatingUtil = (gqlResult) => {
    if (!gqlResult) return null;

    // const fund = gqlResult.mutualFund || gqlResult.exchangeTradedFund;
    // const isEtf = !!gqlResult.exchangeTradedFund;
    // const hasTacked = isEtf
    //     ? false
    //     : fund.monthlyAverageAnnualTotalReturns.threeYearReturnTacked;

    const { mutualFund } = gqlResult;
    const mstarData = {
        inceptionDate: mutualFund.inceptionDate,
        morningStarOverallRating:
            mutualFund.morningStarRatings.morningStarOverallRating,
        morningStarOverallQuantity:
            mutualFund.morningStarRatings.morningStarOverallQuantity,
        morningStarCategoryName:
            mutualFund.morningStarRatings.morningStarCategoryName,
        morningStarAsOfDate: mutualFund.morningStarRatings.morningStarAsOfDate
    };
    const { monthlyAnnualReturns } =
        mutualFund.standardPerformanceReturns || {};
    const { fundPerformance } = monthlyAnnualReturns || {};
    const hasTacked = fundPerformance && fundPerformance.threeYearReturnTacked;

    return { mstarData, hasTacked };
};
